import { ASSETS_API_URL } from "config/api";
import React, { useEffect, useState } from 'react'
import "./dashboard.scss";
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import {
    DEFAULT_TRADING_CONFIG,
    ORDER_TYPES,
    REFERENCE_PRICE_SOURCES,
    TEXT_FIELDS,
    TIME_IN_FORCES,
    TRADING_STATUSES,
    buildCreatePairBody,
    getApiErrorMessages,
    validatePairForm,
} from "./pairTradingConfig";

const INPUT_PROPS_BY_KIND = {
    decimal: { type: "text", inputMode: "decimal" },
    integer: { type: "text", inputMode: "numeric" },
    text: { type: "text" },
    datetime: { type: "datetime-local" },
};

const formatEnumLabel = (value) => value.replace(/_/g, " ");

const DropdownArrow = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
        <path d="M9.29226 0.5H5.21637H1.5461C0.918037 0.5 0.604004 1.25891 1.04888 1.70379L4.43783 5.09274C4.98084 5.63575 5.86406 5.63575 6.40708 5.09274L7.69592 3.80389L9.79602 1.70379C10.2344 1.25891 9.92033 0.5 9.29226 0.5Z" fill="white" />
    </svg>
);

const TickIcon = () => (
    <svg className="pairmarkettick" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M3 8.5L6.5 12L13 4.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const Addpairs = () => {

    const history = useHistory();
    const [markets, setMarkets] = useState([]);
    const [baseMarket, setBaseMarket] = useState(null);
    const [quoteMarket, setQuoteMarket] = useState(null);
    const [isActive, setIsActive] = useState(true);
    const [tradingConfig, setTradingConfig] = useState(DEFAULT_TRADING_CONFIG);
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        const tok = localStorage.getItem("accessTokenDash");
        axios({
            method: "get",
            // isMinimal returns id, name, symbol and icon, which is all this
            // picker needs. The full list is heavier and currently fails.
            url: `${ASSETS_API_URL}/markets?isMinimal=true&page=1&limit=20`,
            headers: {
                authorization: `Bearer ${tok}`
            },
        })
            .then((response) => setMarkets(response?.data?.data || []))
            .catch((error) => console.error("Error fetching markets:", error));
    }, []);

    const clearError = (key) => {
        setErrors((prev) => (prev[key] ? { ...prev, [key]: undefined } : prev));
    };

    const updateConfig = (key, value) => {
        setTradingConfig((prev) => ({ ...prev, [key]: value }));
        clearError(key);
    };

    const toggleInConfig = (key, value) => {
        setTradingConfig((prev) => {
            const list = prev[key];
            const next = list.includes(value) ? list.filter((item) => item !== value) : [...list, value];
            return { ...prev, [key]: next };
        });
        clearError(key);
    };

    const selectBaseMarket = (market) => {
        setBaseMarket(market);
        clearError("baseMarketId");
    };

    const selectQuoteMarket = (market) => {
        setQuoteMarket(market);
        clearError("quoteMarketId");
    };

    const handleSubmit = () => {
        if (submitting) return;

        const form = { baseMarket, quoteMarket, isActive, tradingConfig };
        const formErrors = validatePairForm(form);
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            toast.error("Please fix the highlighted fields", {
                position: "top-right",
                autoClose: 3000,
            });
            // Long form: bring the first problem into view.
            setTimeout(() => {
                document.querySelector(".tokenicon .error")?.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 0);
            return;
        }

        setSubmitting(true);
        const tok = localStorage.getItem("accessTokenDash");
        axios({
            method: "POST",
            url: `${ASSETS_API_URL}/pairs`,
            headers: {
                authorization: `Bearer ${tok}`
            },
            data: buildCreatePairBody(form),
        })
            .then(() => {
                toast.success("Pair Added Successfully", {
                    position: "top-right",
                    autoClose: 3000,
                });
                history.push("pairs");
            })
            .catch((error) => {
                const messages = getApiErrorMessages(error);
                toast.error(
                    <div>{messages.map((message, index) => <div key={index}>{message}</div>)}</div>,
                    { position: "top-right", autoClose: 6000 }
                );
                setSubmitting(false);
            });
    };

    // blockedMarket is the market already chosen in the other dropdown. It is
    // shown with a green tick and cannot be picked, so base and quote differ.
    const renderMarketDropdown = (dropdownId, selected, onSelect, blockedMarket, otherSideLabel) => (
        <div className='shghsdhsdhgj drop'>
            <div className="dropdown buttons-list-all">
                <button className="sfwfqedsvdsfwqwef" type="button" id={dropdownId} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <p className="dvhjbdhjefv">{selected ? `${selected.name} (${selected.symbol})` : 'Select Market'}</p>
                    <DropdownArrow />
                </button>
                <div className="dropdown-menu" aria-labelledby={dropdownId}>
                    {markets.map((market) => {
                        const blocked = !!blockedMarket && blockedMarket.id === market.id;
                        return (
                            <a
                                key={market.id}
                                // "disabled" makes Bootstrap's arrow-key navigation skip this item.
                                className={`dropdown-item pairmarketoption${blocked ? " disabled is-blocked" : ""}`}
                                aria-disabled={blocked}
                                title={blocked ? `Already selected as the ${otherSideLabel} market` : undefined}
                                onClick={(e) => {
                                    if (blocked) {
                                        // Keep the menu open and ignore the click.
                                        e.preventDefault();
                                        e.stopPropagation();
                                        return;
                                    }
                                    onSelect(market);
                                }}
                            >
                                <p>
                                    <span>{market.name} ({market.symbol})</span>
                                    {blocked && <TickIcon />}
                                </p>
                            </a>
                        );
                    })}
                </div>
            </div>
        </div>
    );

    const renderFieldMessage = (key, hint) => {
        if (errors[key]) return <p className="error">{errors[key]}</p>;
        if (hint) return <p className="pairfieldhint">{hint}</p>;
        return null;
    };

    const renderTextField = (key) => {
        const field = TEXT_FIELDS[key];
        return (
            <div className="pairfield" key={key}>
                <p>{field.label}</p>
                <input
                    {...INPUT_PROPS_BY_KIND[field.kind]}
                    className="inputttclass"
                    id={key}
                    placeholder={field.placeholder}
                    value={tradingConfig[key]}
                    onChange={(e) => updateConfig(key, e.target.value)}
                />
                {renderFieldMessage(key, field.hint)}
            </div>
        );
    };

    const renderSelectField = (key, label, options) => (
        <div className="pairfield" key={key}>
            <p>{label}</p>
            <select className="pairselect" id={key} value={tradingConfig[key]} onChange={(e) => updateConfig(key, e.target.value)}>
                {options.map((option) => (
                    <option key={option} value={option}>{formatEnumLabel(option)}</option>
                ))}
            </select>
            {renderFieldMessage(key)}
        </div>
    );

    const renderChipField = (key, label, options) => (
        <div className="pairfield pairfieldwide" key={key}>
            <p>{label}</p>
            <div className="pairchips" role="group" aria-label={label}>
                {options.map((option) => {
                    const selected = tradingConfig[key].includes(option);
                    return (
                        <button
                            type="button"
                            key={option}
                            className={`pairchip${selected ? " selected" : ""}`}
                            aria-pressed={selected}
                            onClick={() => toggleInConfig(key, option)}
                        >
                            {formatEnumLabel(option)}
                        </button>
                    );
                })}
            </div>
            {renderFieldMessage(key)}
        </div>
    );

    return (
        <>
            <img className='elipse img-fluid' src='/assets/main-assets/Ellipse.png' alt="ellipse" />
            <div className="content">
                <div className="tokenicon">
                    <div className='parentheadingnetwok'>
                        <p>Base Market</p>
                        {renderMarketDropdown("baseMarketDropdown", baseMarket, selectBaseMarket, quoteMarket, "quote")}
                        {errors.baseMarketId && <p className="error">{errors.baseMarketId}</p>}
                        <p>Quote Market</p>
                        <div className='drop'>
                            {renderMarketDropdown("quoteMarketDropdown", quoteMarket, selectQuoteMarket, baseMarket, "base")}
                        </div>
                        {errors.quoteMarketId && <p className="error">{errors.quoteMarketId}</p>}
                    </div>

                    <div className="pairformsection">
                        <p className="pairsectiontitle">Trade Limits</p>
                        <p className="pairsectionhint">Allowed order size. Notional is price multiplied by quantity.</p>
                        <div className="pairfieldgrid maininputs">
                            {renderTextField("minTradeAmount")}
                            {renderTextField("maxTradeAmount")}
                            {renderTextField("minNotional")}
                            {renderTextField("maxNotional")}
                        </div>
                    </div>

                    <div className="pairformsection">
                        <p className="pairsectiontitle">Precision</p>
                        <p className="pairsectionhint">How finely prices and quantities can be expressed.</p>
                        <div className="pairfieldgrid maininputs">
                            {renderTextField("pricePrecision")}
                            {renderTextField("priceTickSize")}
                            {renderTextField("quantityPrecision")}
                            {renderTextField("quantityStepSize")}
                        </div>
                    </div>

                    <div className="pairformsection">
                        <p className="pairsectiontitle">Order Rules</p>
                        <p className="pairsectionhint">Which orders traders may place on this pair.</p>
                        <div className="pairfieldgrid maininputs">
                            {renderChipField("allowedOrderTypes", "Allowed Order Types", ORDER_TYPES)}
                            {renderChipField("allowedTimeInForces", "Allowed Time In Force", TIME_IN_FORCES)}
                        </div>
                    </div>

                    <div className="pairformsection">
                        <p className="pairsectiontitle">Risk Controls</p>
                        <p className="pairsectionhint">Limits that protect traders from extreme prices.</p>
                        <div className="pairfieldgrid maininputs">
                            {renderTextField("maxPriceDeviationBps")}
                            {renderTextField("maxSlippageBps")}
                            {renderSelectField("referencePriceSource", "Reference Price Source", REFERENCE_PRICE_SOURCES)}
                        </div>
                    </div>

                    <div className="pairformsection">
                        <p className="pairsectiontitle">Trading Schedule</p>
                        <p className="pairsectionhint">When the pair opens and how it is billed.</p>
                        <div className="pairfieldgrid maininputs">
                            {renderSelectField("tradingStatus", "Trading Status", TRADING_STATUSES)}
                            {renderTextField("tradingStartsAt")}
                            {renderTextField("feeScheduleId")}
                        </div>
                    </div>

                    <div className="listedhead forwidthsss">
                        <p className="availtab">Is Active</p>
                        <label className="switch">
                            <input type="checkbox" checked={isActive} onChange={() => setIsActive((value) => !value)} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                    <div className='addmarketbuttonsss'>
                        <button type='button' onClick={handleSubmit} disabled={submitting}>
                            {submitting ? "Adding Pair..." : "Add Pair"}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Addpairs
